(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-extended"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const desktopQuery = window.matchMedia('(min-width: 600px)');

    const syncControlsState = () => {
      document.querySelectorAll('.collection-section--extended .collection-controls').forEach((controls) => {
        if (desktopQuery.matches) {
          controls.open = true;
        }
      });
    };

    syncControlsState();

    if (desktopQuery.addEventListener) {
      desktopQuery.addEventListener('change', syncControlsState);
    } else {
      desktopQuery.addListener(syncControlsState);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const SCROLL_SOLID_THRESHOLD = 80;
    const DRAWER_OPEN_INTENT_KEY = 'flight:open-cart-on-load';

    const initHeader = (root) => {
      if (!root || root.dataset.flightInit === 'true') return;
      root.dataset.flightInit = 'true';

      const cartPanel = root.querySelector('[data-cart-panel]');
      const cartToggle = root.querySelector('[data-cart-toggle]');
      const cartCloseButtons = root.querySelectorAll('[data-cart-close]');
      const timeNode = root.querySelector('[data-flight-time]');
      const menuToggle = root.querySelector('.flight__menu-toggle');

      const getScrollTop = () => {
        return Math.max(
          window.scrollY || 0,
          window.pageYOffset || 0,
          document.documentElement ? document.documentElement.scrollTop : 0,
          document.body ? document.body.scrollTop : 0
        );
      };

      const syncDrawerSolidState = () => {
        const isScrolled = getScrollTop() > SCROLL_SOLID_THRESHOLD;
        const isMenuOpen = menuToggle ? menuToggle.checked : false;
        const isCartOpen = cartPanel ? cartPanel.classList.contains('is-open') : false;
        const isAnyDrawerOpen = isMenuOpen || isCartOpen;
        root.classList.toggle('flight--scrolled', isScrolled);
        root.classList.toggle('flight--drawer-solid', isAnyDrawerOpen);
        root.classList.toggle('flight--cart-solid', isCartOpen);
      };

      if (timeNode) {
        const tz = timeNode.dataset.timezone || 'UTC';
        const locale = timeNode.dataset.locale || 'en-US';
        const label = timeNode.dataset.label || '';
        const formatter = new Intl.DateTimeFormat(locale, {
          timeZone: tz,
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        });

        const update = () => {
          timeNode.textContent = label ? `${label} ${formatter.format(new Date())}` : formatter.format(new Date());
        };

        update();
        setInterval(update, 1000);
      }

      if (cartPanel && cartToggle) {
        cartToggle.addEventListener('click', () => {
          cartPanel.classList.toggle('is-open');
          syncDrawerSolidState();
        });

        cartCloseButtons.forEach((btn) => {
          btn.addEventListener('click', () => {
            cartPanel.classList.remove('is-open');
            syncDrawerSolidState();
          });
        });
      }

      if (menuToggle) {
        menuToggle.addEventListener('change', syncDrawerSolidState);
      }

      window.addEventListener('scroll', syncDrawerSolidState, { passive: true });
      document.addEventListener('scroll', syncDrawerSolidState, { passive: true });
      window.addEventListener('resize', syncDrawerSolidState, { passive: true });
      syncDrawerSolidState();
      if (cartPanel && window.sessionStorage && sessionStorage.getItem(DRAWER_OPEN_INTENT_KEY) === 'true') {
        cartPanel.classList.add('is-open');
        sessionStorage.removeItem(DRAWER_OPEN_INTENT_KEY);
        syncDrawerSolidState();
      }
    };

    const init = () => {
      document.querySelectorAll('.flight[id^="flight-"]').forEach(initHeader);
    };

    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      const action = form.getAttribute('action') || '';
      if (!action.includes('/cart/add')) return;
      if (window.sessionStorage) {
        sessionStorage.setItem(DRAWER_OPEN_INTENT_KEY, 'true');
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('video[data-ping-pong="true"]').forEach((video) => {
    let rafId = null;
    let reversing = false;
    let lastTime = null;

    const tick = (now) => {
      if (!reversing) return;
      if (lastTime === null) lastTime = now;
      const delta = (now - lastTime) / 1000;
      lastTime = now;
      const rate = video.playbackRate || 1;
      const nextTime = video.currentTime - delta * rate;

      if (nextTime <= 0) {
        video.currentTime = 0;
        reversing = false;
        lastTime = null;
        video.play();
        return;
      }

      video.currentTime = nextTime;
      rafId = requestAnimationFrame(tick);
    };

    video.addEventListener('ended', () => {
      if (reversing) return;
      reversing = true;
      lastTime = null;
      video.pause();
      rafId = requestAnimationFrame(tick);
    });

    video.addEventListener('play', () => {
      if (reversing) video.pause();
    });

    video.addEventListener('remove', () => {
      if (rafId) cancelAnimationFrame(rafId);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
